import BaseApi from './base/BaseApi';

export default class CrmStageApi extends BaseApi {
  static entityName = 'crm_stages';
}
